import { useRouter } from "next/router";
import { IRankingExtendedSearch } from "src/api/server/extended-search";
import { ComboBox, ComboBoxItem } from "src/components/base/combo-box";
import { ISortDirectionType } from "src/types/common";
import { ISelectedRanking } from "../types";

type IDropdownSelectorProps = {
    rankings: ReadonlyArray<IRankingExtendedSearch>;
    selectedRanking: ISelectedRanking;
    relevanceRanking: IRankingExtendedSearch;
    isDisabled: boolean;
    onChange: (selectedRanking: ISelectedRanking) => void;
};

export const RankingsDropdownSelector = ({ rankings, selectedRanking, relevanceRanking, isDisabled, onChange }: IDropdownSelectorProps) => {
    const router = useRouter();
    const { searchTerm } = router.query;

    const handleOnChange = (id: string) => {
        const defaultSortDirectionForSelectedRanking: ISortDirectionType = rankings.find(ranking => ranking.id === id)?.sortDirection ?? null;
        onChange({ id, sortDirection: defaultSortDirectionForSelectedRanking });
    };

    const shouldRelevanceRankingBeDisabled = (id: string) => relevanceRanking.id === id && !Boolean(searchTerm);

    return (
        <ComboBox
            value={selectedRanking.id}
            onChange={handleOnChange}
            inputBoxProps={{
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "block",
                overflow: "hidden",
                textAlign: "left",
                pr: 3,
            }}
            menuListProps={{
                maxH: 256,
                width: 250,
            }}
            isDisabled={isDisabled}
        >
            {rankings.map(({ id, label }) => (
                <ComboBoxItem
                    key={id}
                    value={id}
                    sx={{ textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inherit", overflow: "hidden" }}
                    h={5}
                    isDisabled={shouldRelevanceRankingBeDisabled(id)}
                >
                    {label}
                </ComboBoxItem>
            ))}
        </ComboBox>
    );
};
